import { Dispatch } from 'redux'
import { stateToRegionByName } from '../constants/Map/stateRegionMap'
import { AmericanStatesActions } from '../store/AmericanStates'
import { MapActions } from '../store/Map'
import { WaterSystemCoordinatesActions } from '../store/publicWaterSystem'

export const getStateCountiesPolygon = async (code?: string) => {
  if (!code) return null

  try {
    const stateGeoData = await getCountyGeoDataFromFile(code.toLowerCase())
    if (stateGeoData) {
      return stateGeoData
    } else {
      console.warn(`No geo data found for state: ${code}`)
      return null
    }
  } catch (error) {
    console.error('Error fetching state counties polygon:', error)
    return null
  }
}

const getCountyGeoDataFromFile = async (code: string) => {
  try {
    const stateGeoData = await import(`../constants/Map/polygons/counties/${code}.json`)
    return stateGeoData
  } catch (error) {
    console.error(`Error loading GeoJSON file for state: ${code}`, error)
    return null
  }
}

export const getStateCode = (stateName: string): string | null => {
  if (!stateName) return null

  const normalizedStateName = stateName.toLowerCase()

  const stateEntry = Object.entries(stateToRegionByName).find(
    ([name]) => name.toLowerCase() === normalizedStateName,
  )

  return stateEntry ? stateEntry[1].code : null
}

export const handleMapZoomOnZip = (data: any, americanStates: any[], dispatch: Dispatch) => {
  if (!data) return
  const selectedStateAbbr = data?.waterSystems && data?.waterSystems[0]?.STATE_CODE
  const addressCenter = data?.center && data?.center

  const waterSystemState = americanStates.find(
    (state: any) => state.state_abbr === selectedStateAbbr,
  )

  waterSystemState && dispatch(AmericanStatesActions.setSelectedState(waterSystemState))

  if (addressCenter) {
    const { lat, lng } = addressCenter
    dispatch(MapActions.setMapCenter({ lat, lng }))
    dispatch(MapActions.setMapZoom({ zoom: 11 }))
    dispatch(
      WaterSystemCoordinatesActions.setWaterSystemCoordinates({
        items: data.waterSystems,
        boundingBox: data.boundingBox,
        invalidIdx: [],
      }),
    )
  }
}
